export const corporations = {
  Add_a_New_Company: "Adicionar uma Nova Empresa",
  Add_Another_Admin: "Adicionar Outro Administrador",
  Add_Company: "Adicionar Empresa",
  Add_new_company: "Adicionar nova empresa",
  Companies: "Empresas",
  company_management: "gerenciamento de empresa",
  Company_name: "Nome da empresa",
  "Created at": "Criado em",
  Edit_Company: "Editar Empresa",
  Name: "Nome",
  Organisation_Admins: "Administradores da Organização",
  Please_enter_the_basic_company_information: "Por favor, insira as informações básicas da empresa",
  Status: "Status",
  Update_company: "Atualizar empresa",
  Use_this_window_to_add_a_new_company_data_on_the_platform:
    "Use esta janela para adicionar dados de uma nova empresa na plataforma",
  Use_this_window_to_edit_company_data_on_the_platform: "Use esta janela para editar dados da empresa na plataforma",
} as const;
